/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These are the official Formula 1 World Championship points, scored by the real-world race system (25 for a win, down the order). They are separate from F1 Fantasy points. Use the standings to gauge driver and team form, then check the Fantasy Points page to see how that form scores in the game.`)
};

const es_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estos son los puntos oficiales del Campeonato Mundial de Fórmula 1, otorgados según el sistema de puntuación real de las carreras (25 por una victoria, y así en orden descendente). Son independientes de los puntos de F1 Fantasy. Usa la clasificación para evaluar la forma de pilotos y equipos, y luego revisa la página de Puntos Fantasy para ver cómo puntúa esa forma en el juego.`)
};

const de_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das sind die offiziellen Punkte der Formel-1-Weltmeisterschaft, vergeben nach dem realen Renn-Punktesystem (25 für einen Sieg, absteigend). Sie sind unabhängig von F1-Fantasy-Punkten. Nutze die Tabelle, um die Form von Fahrern und Teams einzuschätzen, und schau dann auf der Seite Fantasy-Punkte nach, wie sich diese Form im Spiel niederschlägt.`)
};

const nl_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit zijn de officiële punten van het Formule 1-wereldkampioenschap, toegekend volgens het echte race-puntensysteem (25 voor een overwinning, aflopend). Ze staan los van F1 Fantasy-punten. Gebruik de stand om de vorm van coureurs en teams te beoordelen, en controleer dan de pagina Fantasy-punten om te zien hoe die vorm scoort in het spel.`)
};

const fr_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce sont les points officiels du Championnat du Monde de Formule 1, attribués selon le système de points réel des courses (25 pour une victoire, en descendant). Ils sont distincts des points F1 Fantasy. Utilisez le classement pour évaluer la forme des pilotes et des équipes, puis consultez la page Points Fantasy pour voir comment cette forme se traduit en points dans le jeu.`)
};

const it_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questi sono i punti ufficiali del Campionato del Mondo di Formula 1, assegnati secondo il sistema di punteggio reale delle gare (25 per una vittoria, a scendere). Sono separati dai punti F1 Fantasy. Usa la classifica per valutare la forma di piloti e team, poi controlla la pagina Punti Fantasy per vedere come quella forma si traduce in punti nel gioco.`)
};

const pt_br2_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esses são os pontos oficiais do Campeonato Mundial de Fórmula 1, atribuídos segundo o sistema de pontuação real das corridas (25 por uma vitória, e assim por diante). Eles são independentes dos pontos de F1 Fantasy. Use a classificação para avaliar a forma de pilotos e times, e depois confira a página Pontos Fantasy para ver como essa forma pontua no jogo.`)
};

const pt_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estes são os pontos oficiais do Campeonato Mundial de Fórmula 1, atribuídos segundo o sistema de pontuação real das corridas (25 por uma vitória, e assim por diante). São independentes dos pontos de F1 Fantasy. Use a classificação para avaliar a forma de pilotos e equipas, e depois consulte a página Pontos Fantasy para ver como essa forma pontua no jogo.`)
};

const ja_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これは実際のレースのポイントシステム（優勝で25点、以下順位に応じて減少）で採点される、公式のフォーミュラ1世界選手権ポイントです。F1ファンタジーポイントとは別物です。順位表を使ってドライバーやチームのフォームを判断し、Fantasy Pointsページでそのフォームがゲーム内でどう得点になるかを確認してください。`)
};

const zh_f1_st_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些是官方的一级方程式世界锦标赛积分,按照真实比赛计分体系(冠军25分,依次递减)计算,与F1梦幻积分是分开的。使用积分榜评估车手和车队的状态,然后查看梦幻积分页面,了解这种状态在游戏中如何计分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_st_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_st_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_st_faq1_a", locale)
	if (locale === "en") return en_f1_st_faq1_a(inputs)
	if (locale === "es") return es_f1_st_faq1_a(inputs)
	if (locale === "de") return de_f1_st_faq1_a(inputs)
	if (locale === "nl") return nl_f1_st_faq1_a(inputs)
	if (locale === "fr") return fr_f1_st_faq1_a(inputs)
	if (locale === "it") return it_f1_st_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_st_faq1_a(inputs)
	if (locale === "pt") return pt_f1_st_faq1_a(inputs)
	if (locale === "ja") return ja_f1_st_faq1_a(inputs)
	return zh_f1_st_faq1_a(inputs)
};